export function normalizeInternalLinkValue(value) {
    return typeof value === "string" ? value.trim() : "";
}
export function escapeMarkdownLinkText(value) {
    return value.replaceAll("\\", "\\\\").replaceAll("[", "\\[").replaceAll("]", "\\]");
}
export function parseInternalHref(value) {
    try {
        return value.startsWith("/") ? new URL(value, "https://example.local") : new URL(value);
    }
    catch {
        return null;
    }
}
